<template>
  <nav>
    <div class="nav-container">
      <!-- ☰ 漢堡按鈕 -->
      <button class="hamburger" @click="toggleMenu">☰</button>

      <!-- 導覽列 -->
      <div :class="['nav-items', { open: isMenuOpen }]">
        <router-link to="/" class="nav-item logo" @click="closeMenu">
          <img src="@/assets/logo.png" alt="首頁 Logo" />
        </router-link>

        <div class="dropdown" :class="{ open: openDropdown === 'calculator' }">
          <a class="nav-item" style="cursor: default;" @click="toggleDropdown($event, 'calculator')">計算機</a>
          <div class="dropdown-content">
            <router-link to="/calculator/hexa" class="nav-item" @click="closeMenu">六轉進度計算機</router-link>
            <router-link to="/calculator/exp" class="nav-item" @click="closeMenu">經驗計算機</router-link>
            <span class="nav-item disabled">經驗回推計算機 (暫時停用)</span>
          </div>
        </div>

        <div class="dropdown" :class="{ open: openDropdown === 'simulator' }">
          <a class="nav-item" style="cursor: default;" @click="toggleDropdown($event, 'simulator')">模擬器</a>
          <div class="dropdown-content">
            <router-link to="/simulator/jewel" class="nav-item" @click="closeMenu">寶玉模擬器</router-link>
            <router-link to="/simulator/hexa-stats" class="nav-item" @click="closeMenu">Hexa屬性模擬器</router-link>
          </div>
        </div>

        <div class="dropdown" :class="{ open: openDropdown === 'links' }">
          <a class="nav-item" style="cursor: default;" @click="toggleDropdown($event, 'links')">相關連結</a>
          <div class="dropdown-content">
            <a href="https://maplestory.beanfun.com/main" target="_blank" class="nav-item">官方網站</a>
            <a href="https://www.facebook.com/www.maplestory.msfans.com.tw/?locale=zh_TW" target="_blank" class="nav-item">官方粉絲團</a>  
            <a href="https://home.gamer.com.tw/creationDetail.php?sn=2528312" target="_blank" class="nav-item">人物名稱對照表</a>
          </div>
        </div>

        <div class="dropdown" :class="{ open: openDropdown === 'tools' }">
          <a class="nav-item" style="cursor: default;" @click="toggleDropdown($event, 'tools')">其他工具</a>
          <div class="dropdown-content">
            <a href="https://xenogents.github.io/LegionSolver/" target="_blank" class="nav-item">戰地拼圖計算機</a>
            <a href="https://msh.astriaworks.moe/" target="_blank" class="nav-item">極限屬性計算機</a>
            <a href="https://maplemaps.net/" target="_blank" class="nav-item">怪物地圖</a>
          </div>
        </div>
        
        <router-link to="/#favorites-title" class="nav-item" @click="navToFavorites">收藏</router-link>
      </div>
    </div>
  </nav>

  <main>
    <router-view></router-view>
  </main>

  <footer class="footer">
    <p>Copyright © 2025 shanshan 版權所有</p>
  </footer>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      isMenuOpen: false,
      openDropdown: null
    };
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
      if (!this.isMenuOpen) {
        this.openDropdown = null;
      }
    },
    closeMenu() {
      this.isMenuOpen = false;
      this.openDropdown = null;
    },
    toggleDropdown(event, dropdownName) {
      if (window.innerWidth <= 768) {
        event.preventDefault();
        this.openDropdown = this.openDropdown === dropdownName ? null : dropdownName;
      }
    },
    scrollToAnchor() {
      // 延遲執行，確保路由跳轉完成
      setTimeout(() => {
        const hash = window.location.hash;
        if (hash) {
          const element = document.querySelector(hash);
          if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }
      }, 100);
    },
    navToFavorites() {
      this.closeMenu();
      setTimeout(() => {
        const element = document.getElementById('favorites-title');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    },
    navToAnchor(anchor) {
      this.closeMenu();
      setTimeout(() => {
        const element = document.getElementById(anchor);
        if (element) {
          // 創建一個特殊偏移，用於提醒標題
          let offset = 0;
          if (anchor === 'reminder-title') {
            offset = -70; // 在提醒標題上方60px的位置
          }
          
          // 獲取元素位置並添加偏移
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset + offset;
          
          // 滾動到計算後的位置
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }, 100);
    }
  },
  mounted() {
    // 檢查是否有錨點需要滾動到
    if (window.location.hash) {
      this.scrollToAnchor();
    }
    
    // 監聽路由變化，處理錨點跳轉
    window.addEventListener('hashchange', this.scrollToAnchor);
  },
  beforeDestroy() {
    // 清除事件監聽器
    window.removeEventListener('hashchange', this.scrollToAnchor);
  }
};
</script>

<style>
@import url('https://cdn.jsdelivr.net/npm/lxgw-wenkai-tc-webfont@1.6.0/style.css');

:root {
  --primary-color: #4a90e2;
  --secondary-color: #2c3e50;
  --accent-color: #e74c3c;
  --background-color: #f5f7fa;
  --text-color: #2c3e50;
  --nav-bg: #2c3e50;
  --nav-hover: #34495e;
  --card-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  --transition-speed: 0.3s;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'LXGW WenKai TC', 'Microsoft JhengHei', Arial, sans-serif;
  background-color: var(--background-color);
  color: var(--text-color);
  line-height: 1.6;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

nav {
  background-color: var(--nav-bg);
  padding: 1rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 1000;
}

.nav-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 14%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.nav-item.logo img {
  height: 32px;
  width: auto;
  display: block;
}

.hamburger {
  display: none;
  font-size: 24px;
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  padding: 0 0.5rem;
  line-height: 1;
  z-index: 1100;
}

.nav-items {
  display: flex;
  gap: 1.5rem;
  align-items: center;
}

.nav-item {
  color: white;
  text-decoration: none;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  transition: all var(--transition-speed) ease;
  position: relative;
  overflow: hidden;
  font-weight: 700;
  letter-spacing: 0.5px;
  font-family: 'LXGW WenKai TC', serif;
}

.nav-item::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  width: 0;
  height: 2px;
  background-color: var(--accent-color);
  transition: all var(--transition-speed) ease;
  transform: translateX(-50%);
}

.nav-item:hover {
  background-color: var(--nav-hover);
}

.nav-item:hover::after {
  width: 100%;
}

.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-content {
  display: none;
  position: absolute;
  background-color: white;
  min-width: 240px;
  border-radius: 8px;
  box-shadow: var(--card-shadow);
  z-index: 1;
  opacity: 0;
  transform: translateY(-10px);
  transition: all var(--transition-speed) ease;
  overflow: hidden;
  margin-top: 5px;
}

.dropdown-content .nav-item::after {
  display: none;
}

.dropdown:hover .dropdown-content {
  display: block;
  opacity: 1;
  transform: translateY(0);
}

.dropdown-content a,
.dropdown-content span {
  color: var(--text-color);
  padding: 12px 16px;
  text-decoration: none;
  display: block;
  transition: all var(--transition-speed) ease;
  border-left: 3px solid transparent;
  font-weight: 300;
  font-family: 'LXGW WenKai TC', serif;
}

.dropdown-content a:first-child {
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.dropdown-content a:last-child {
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
}

.dropdown-content a:hover {
  background-color: #f8f9fa;
  border-left: 3px solid var(--accent-color);
  padding-left: 20px;
}

.dropdown-content a.disabled,
.dropdown-content span.disabled {
  color: #999;
  cursor: not-allowed;
  opacity: 0.6;
}

.dropdown-content a.disabled:hover,
.dropdown-content span.disabled:hover {
  background-color: transparent;
  border-left: 3px solid transparent;
  padding-left: 16px;
}

main {
  max-width: 1200px;
  margin: 2rem auto;
  padding: 0 1rem;
  animation: fadeIn 0.5s ease;
  flex: 1;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.footer {
  text-align: center;
  padding: 1.5rem;
  color: #666;
  margin-top: auto;
}

.footer p {
  margin: 0;
  font-size: 0.9rem;
}

/* 響應式樣式 */
@media (max-width: 768px) {
  .hamburger {
    display: block;
    position: relative;
    top: auto;
    right: auto;
    z-index: 1100;
    background: none;
    border: none;
    color: white;
    font-size: 1.75rem;
    padding: 0.5rem;
    cursor: pointer;
    margin-left: auto;
    width: 48px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .nav-container {
    padding: 0 0.5rem;
    justify-content: space-between;
    min-height: 48px;
  }

  .nav-items {
    display: none;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: var(--nav-bg);
    flex-direction: column;
    gap: 0;
    padding: 3.5rem 0 0;
    overflow-y: auto;
    z-index: 1000;
    transform: translateX(-100%);
    transition: transform 0.3s ease;
  }

  .nav-items.open {
    display: flex;
    transform: translateX(0);
  }

  .nav-item {
    width: 100%;
    text-align: left;
    padding: 1rem 1.5rem;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    white-space: nowrap;
    min-height: 48px;
    display: flex;
    align-items: center;
  }

  .nav-item.logo {
    display: flex;
    align-items: center;
  }

  .nav-item.logo img {
    display: none;
  }

  .nav-item.logo::before {
    content: "首頁";
    color: white;
    font-size: 1rem;
    font-weight: 700;
  }

  .dropdown {
    width: 100%;
  }

  .dropdown-content {
    position: static;
    display: none;
    background-color: rgba(255, 255, 255, 0.05);
    box-shadow: none;
    margin: 0;
    border-radius: 0;
    opacity: 1;
    transform: none;
  }

  .dropdown:hover .dropdown-content {
    display: none;
  }

  .dropdown.open .dropdown-content {
    display: block;
  }

  .dropdown-content a:hover {
    background-color: rgba(255, 255, 255, 0.1);
    border-left: none;
    padding-left: 2rem;
  }

  .dropdown-content a.disabled,
  .dropdown-content span.disabled {
    color: rgba(255, 255, 255, 0.5);
    opacity: 0.6;
  }

  .dropdown-content a.disabled:hover,
  .dropdown-content span.disabled:hover {
    background-color: transparent;
    border-left: none;
    padding-left: 2rem;
  }
}
</style>
